import { GatewayData, NotificationData, PlanData, TicketData, TicketMessageData } from "../entry/server/app";
import { UserVIPData } from "../entry/server/user";
import { ApiResponse } from "../lib/api";
import { appService } from "../services/app-service";

export const appRepo = {
    getHomePageData: async () => {
        return await appService.getHomePageData();
    },
    getMenuData: async () => {
        return await appService.getMenuData();
    },
    getAppLinks: async () => {
        return await appService.getAppLinks();
    },
    getTickets: async (page: number): Promise<ApiResponse<TicketData[]>> => {
        return await appService.getTickets(page);
    },
    getTicket: async (ticketId: number): Promise<ApiResponse<{ ticket: TicketData, messages: TicketMessageData[] }>> => {
        return await appService.getTicket(ticketId);
    },
    createTicket: async (title: string, priority: 'low' | 'medium' | 'high' | 'critical', description: string): Promise<ApiResponse<TicketData>> => {
        return await appService.createTicket(title, priority, description);
    },
    replyToTicket: async (ticketId: number, message: string): Promise<ApiResponse<TicketData>> => {
        return await appService.replyToTicket(ticketId, message);
    },
    getPlans: async (): Promise<ApiResponse<PlanData[]>> => {
        return await appService.getPlans()
    },
    getGateways: async (): Promise<ApiResponse<GatewayData[]>> => {
        return await appService.getGateways();
    },
    applyDiscountCode: async (code: string): Promise<ApiResponse<PlanData[]>> => {
        return await appService.applyDiscountCode(code);
    },
    createPayment: async (planId: number, gatewayId: number, discountCode?: string): Promise<ApiResponse<string>> => {
        return await appService.createPayment(planId, gatewayId, discountCode);
    },
    verifyPayment: async (paymentId: number): Promise<ApiResponse<UserVIPData>> => {
        return await appService.verifyPayment(paymentId);
    },
    createWalletPayment: async (amount: number, gatewayId: number): Promise<ApiResponse<string>> => {
        return await appService.createWalletPayment(amount, gatewayId);
    },
    verifyWalletPayment: async (paymentId: number): Promise<ApiResponse<void>> => {
        return await appService.verifyWalletPayment(paymentId);
    },
    getNotifications: async (page: number): Promise<ApiResponse<NotificationData[]>> => {
        return await appService.getNotifications(page);
    },
    markAllNotificationsAsRead: async (): Promise<ApiResponse<void>> => {
        return await appService.markAllNotificationsAsRead();
    }
};